import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import Select from 'react-select';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

export default function StepOne({data, incrementStep, handleClose}) {
  const genderOpts = [
    {value: 'male', label: 'Male'},
    {value: 'female', label: 'Female'}
  ];
  const schoolYearOpts = [
    {value: 'reception', label: 'Reception'},
    {value: '1', label: 'Year 1'},
    {value: '2', label: 'Year 2'},
    {value: '3', label: 'Year 3'},
    {value: '4', label: 'Year 4'},
    {value: '5', label: 'Year 5'},
    {value: '6', label: 'Year 6'},
    {value: '7', label: 'Year 7'},
    {value: '8', label: 'Year 8'},
    {value: '9', label: 'Year 9'},
    {value: '10', label: 'Year 10'},
    {value: '11', label: 'Year 11'}
  ];
  const mealBenefitOpts = [
    {value: 'yes', label: 'Yes'},
    {value: 'no', label: 'No'}
  ];

  const isGenderEmpty = genderOpts.find(obj => obj.value === data.gender);
  const [selectedGender] = useState(isGenderEmpty ? {value: isGenderEmpty.value, label: isGenderEmpty.label} : null);
  const isYearEmpty = schoolYearOpts.find(obj => obj.value === data.schoolYear);
  const [selectedYear] = useState(isYearEmpty ? {value: isYearEmpty.value, label: isYearEmpty.label} : null);
  const isBenefitEmpty = mealBenefitOpts.find(obj => obj.value === data.mealBenefit);
  const [selectedBenefit] = useState(isBenefitEmpty ? {value: isBenefitEmpty.value, label: isBenefitEmpty.label} : null);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('Required'),
    lastName: Yup.string().required('Required'),
    dob: Yup.date().required('Required'),
    gender: Yup.string().required('Required'),
    school: Yup.string().required('Required'),
    schoolYear: Yup.string().required('Required'),
    mealBenefit: Yup.string().required('Required')
  });

  return (
    <div className='child-reg-step'>
      <Formik
        initialValues={data}
        validationSchema={validationSchema}
        onSubmit={(values) => incrementStep(values)}
        >
        {({
          values,
          setFieldValue,
          handleChange,
          handleSubmit
        }) => (
          <Form onSubmit={handleSubmit}>
            <div className='row g-0 form-body p-3 custom-scrollbar'>
              <div className='col-md-12'>
                <div className='row g-0'>
                  <div className='col-md-6 pe-md-3'>
                    <Form.Group className="mb-3">
                      <Form.Label>First Name</Form.Label>
                      <Form.Control
                        type="text"
                        name='firstName'
                        placeholder="Enter first name"
                        value={values.firstName}
                        onChange={handleChange}
                      />
                      <ErrorMessage name='firstName' component='p' className='error-message' />
                    </Form.Group>
                  </div>
                  <div className='col-md-6'>
                    <Form.Group className="mb-3">
                      <Form.Label>Last Name</Form.Label>
                      <Form.Control
                        type="text"
                        name='lastName'
                        placeholder="Enter last name"
                        value={values.lastName}
                        onChange={handleChange}
                      />
                      <ErrorMessage name='lastName' component='p' className='error-message' />
                    </Form.Group>
                  </div>
                </div>
                <div className='row g-0'>
                  <div className='col-md-6 pe-md-3'>
                    <Form.Group className="mb-3">
                      <Form.Label>Date of Birth</Form.Label>
                      <Form.Control
                        type="date"
                        name='dob'
                        value={values.dob}
                        onChange={handleChange}
                      />
                      <ErrorMessage name='dob' component='p' className='error-message' />
                    </Form.Group>
                  </div>
                  <div className='col-md-6'>
                    <Form.Group className="mb-3">
                      <Form.Label>Gender</Form.Label>
                      <Select
                        name='gender'
                        options={genderOpts}
                        isSearchable={false}
                        isClearable={false}
                        defaultValue={selectedGender}
                        onChange={(opt) => setFieldValue('gender', opt.value)}
                      />
                      <ErrorMessage name='gender' component='p' className='error-message' />
                    </Form.Group>
                  </div>
                </div>
                <div className='row g-0'>
                  <div className='col-md-6 pe-md-3'>
                    <Form.Group className="mb-3">
                      <Form.Label>School Attending</Form.Label>
                      <Form.Control
                        type="text"
                        name='school'
                        placeholder="Enter school name"
                        value={values.school}
                        onChange={handleChange}
                      />
                      <ErrorMessage name='school' component='p' className='error-message' />
                    </Form.Group>
                  </div>
                  <div className='col-md-6'>
                    <Form.Group className="mb-3">
                      <Form.Label>Year in School</Form.Label>
                      <Select
                        name='schoolYear'
                        options={schoolYearOpts}
                        isSearchable={false}
                        isClearable={false}
                        defaultValue={selectedYear}
                        onChange={(opt) => setFieldValue('schoolYear', opt.value)}
                      />
                      <ErrorMessage name='schoolYear' component='p' className='error-message' />
                    </Form.Group>
                  </div>
                </div>
                <div className='row g-0'>
                  <div className='col-md-6 pe-md-3'>
                    <Form.Group className="mb-3">
                      <Form.Label>Does the child get benefit related free school meals?</Form.Label>
                      <Select
                        name='mealBenefit'
                        options={mealBenefitOpts}
                        isSearchable={false}
                        isClearable={false}
                        defaultValue={selectedBenefit}
                        onChange={(opt) => setFieldValue('mealBenefit', opt.value)}
                      />
                      <ErrorMessage name='mealBenefit' component='p' className='error-message' />
                    </Form.Group>
                  </div>
                </div>  
              </div>
            </div>
            <div className='form-foot p-3 d-flex justify-content-end'>
              <Button variant='secondary' type='button' size='sm' className='me-2' onClick={handleClose}>
                Cancel
              </Button>
              <Button variant='primary' type='submit' size='sm'>
                Next
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}
